import React, { forwardRef } from "react";
import { CSSTransition } from "react-transition-group";
import Popover, { PopoverUIProps } from "./popover";
import "./transitionPopover.css";

export interface TransitionPopoverUIProps extends PopoverUIProps {
    uiActive?: boolean;
    uiTransitionSuffix?: string;
    uiTransitionTimeouts?: number | { enter?: number; exit?: number };
}

export type TransitionPopoverProps = TransitionPopoverUIProps;

const TransitionPopover = forwardRef<Popover, TransitionPopoverProps>(
    ({ uiActive, uiTransitionSuffix = "transition", uiTransitionTimeouts = 200, ...other }, ref) => (
        <CSSTransition
            in={uiActive}
            appear
            enter
            exit
            mountOnEnter
            unmountOnExit
            classNames={uiTransitionSuffix}
            timeout={uiTransitionTimeouts}
        >
            <Popover {...other} ref={ref} />
        </CSSTransition>
    )
);

TransitionPopover.displayName = "TransitionPopover";

export default TransitionPopover;
